/*
 * Game state
 * ==========
 *
 * A sample Game state, displaying the Phaser logo.
 */

// import Logo from '../objects/Logo';
// import Hieroglyphs from '../objects/Hieroglyphs';
// import Map from '../objects/Map';
import Player from '../objects/Player';

export default class Game extends Phaser.State {

  create() {
    // TODO: Replace this with really cool game code here :)

    // const {centerX: x, centerY: y} = this.world;

    this.setupMap();
    this.setupText();
    this.createPlayer();
    this.createControls();
    this.createSandEmitter();
  }

  update() {
    this.checkCollisions();
    this.playerMovement();
    this.playerActions();
    this.cameraMovement();
  }

  findObjectsByType(type, map, layer) {
    let result = [];

    map.objects[layer].forEach((element) => {
      if (element.type === type) {
        result.push(element);
      }
    });

    return result;
  }

  setupMap() {
    let createLayer = (layer) => this.map.createLayer(layer);

    this.map = this.add.tilemap('map1');
    this.map.addTilesetImage('hieroglyphs', 'hieroglyphs');

    this.backgroundColorLayer = createLayer('backgroundColorLayer');
    this.backgroundLayer = createLayer('backgroundLayer');
    this.blocksLayer = createLayer('blocksLayer');

    this.blocksLayer.resizeWorld();
    this.map.setCollisionBetween(1, 2000, true, 'blocksLayer');

    this.setupBreakableBlocks();
  }

  setupBreakableBlocks() {
    let blocks = this.map.objects.breakableBlocksLayer;

    this.breakableBlocks = this.add.group();
    this.breakableBlocks.enableBody = true;
    this.breakableBlocks.physicsBodyType = Phaser.Physics.ARCADE;

    blocks.forEach(block => {
      this.breakableBlocks.create(block.x, block.y - 32, 'hieroglyphs', 32);
    });

    this.breakableBlocks.setAll('body.immovable', true);
  }

  setupText() {

    let style = {
      font: 'Arial',
      fill: '#ddd',
      stroke: '#222',
      strokeThickness: 5
    };
    // Geomorph
    {
      let text = 'Geomorph';
      let textObject = this.add.text(6, 32, text, style);

      textObject.fontSize = 20;
    }
    // by bazoo
    {
      let text = 'by bazoo';
      let textObject = this.add.text(6, 64, text, style);

      textObject.fontSize = 12;
    }
  }

  createPlayer() {
    let {x, y} = this.findObjectsByType('position', this.map, 'objectsLayer')[0];

    this.player = new Player(this.game, x, y);
    this.player.anchor.set(0.5);
    this.player.cube();
    this.physics.enable(this.player, Phaser.Physics.ARCADE);
    this.add.existing(this.player);
    this.player.body.collideWorldBounds = true;
    this.player.body.gravity.y = this.player.stats.gravity;
  }

  createControls() {
    let getKey = (key) => this.input.keyboard.addKey(Phaser.Keyboard[key]);

    this.jumpKey = getKey('W');
    this.leftKey = getKey('A');
    this.rightKey = getKey('D');
    this.ballKey = getKey('RIGHT');
    this.coneKey = getKey('UP');
    this.cubeKey = getKey('LEFT');
    this.specialKey = getKey('SHIFT');
  }

  createSandEmitter() {
    this.sandEmitter = this.add.emitter(0, 0, 200);

    this.sandEmitter.makeParticles('sand');
    this.sandEmitter.gravity = 200;
    this.sandEmitter.setAlpha(1, 0, 500);
  }

  checkCollisions() {
    this.physics.arcade.collide(this.player, this.blocksLayer);

    this.physics.arcade.collide(this.player, this.breakableBlocks, (player, block) => {
      player.onBlock = true;

      if (player.form === 'cube') {
        this.emitSandParticles(block.x + 16, block.y + 16, 50);
        block.kill();
      }
    });
  }

  playerMovement() {
    let velocity = this.player.body.velocity;
    let player = this.player;

    // update dash counter
    if (player.dashCounter > 0)
      player.dashCounter--;


    // stop when no key pressed.
    velocity.x = 0;

    if (this.rightKey.isUp && this.leftKey.isUp &&
    !(player.form == 'cone' && this.specialKey.isDown))
      player.angle = 0;

    // move left or right
    if (this.leftKey.isDown) {
      velocity.x = -player.stats.speed;
      if (player.form !== 'cone')
        player.moveEffect('left');

    } else if (this.rightKey.isDown) {
      velocity.x = player.stats.speed;
      if (player.form !== 'cone')
        player.moveEffect('right');
    }

    // jump
    if (this.jumpKey.isDown && (player.body.onFloor() || player.onBlock) &&
      !(this.specialKey.isDown && player.form === 'cube')) {
      player.body.velocity.y = -player.stats.jump;
      player.onBlock = false;
    }

    // change stats and form
    if (this.ballKey.isDown) {
      this.emitSandParticles(player.x, player.y, 2);
      player.ball();
    }
    if (this.coneKey.isDown) {
      this.emitSandParticles(player.x, player.y, 2);
      player.cone();
    }
    if (this.cubeKey.isDown) {
      this.emitSandParticles(player.x, player.y, 2);
      player.cube();
    }

    // Special key
    if (this.specialKey.isDown) {


      if (this.leftKey.isDown) {
        this.playerActions('left');

        if (player.body.onFloor() || player.onBlock)
          this.emitSandParticles(player.x + 8, player.y + 8, 2);

      } else if (this.rightKey.isDown) {
        this.playerActions('right');

        if (player.body.onFloor() || player.onBlock)
          this.emitSandParticles(player.x - 8, player.y + 8, 2);

      } else {
        player.angle = 0;
        this.playerActions();
      }

    } else {
      // stats reset
      player.stats.jump = player.DEFAULT_STATS[player.form].jump;
      player.stats.speed = player.DEFAULT_STATS[player.form].speed;
      player.stats.gravity = player.DEFAULT_STATS[player.form].gravity;
    }

  }

  coneDash(direction) {
    let player = this.player;

    if (this.nextDashAt > this.time.now)
      return;

    this.nextDashAt = this.time.now + player.CONE_DASH_DELAY;

    if (direction === 'left') {
      player.angle = -player.CONE_DASH_ANGLE;
      player.body.velocity.x -= player.CONE_DASH_BOOST;
    } else if (direction === 'right') {
      player.body.velocity.x += player.CONE_DASH_BOOST;
      player.angle = player.CONE_DASH_ANGLE;
    }
  }

  playerActions(direction) {
    let player = this.player;

    if (this.specialKey.isDown) {
      switch (player.form) {

      case 'ball':
        player.stats.speed = player.BALL_SPEED_BOOST;
        break;

      case 'cone':
        this.coneDash(direction);
        break;

      case 'cube':
        player.body.velocity.y += player.CUBE_STOMP_SPEED;
        break;
      }
    }
  }

  cameraMovement() {
    this.camera.follow(this.player);
  }

  emitSandParticles(x, y, amount) {
    this.sandEmitter.x = x;
    this.sandEmitter.y = y;

    this.sandEmitter.start(true, 200, 20, amount);
  }
}
